import React from 'react'
import PropTypes from 'prop-types'

import { Card, List } from 'semantic-ui-react'

import CardProperty from 'Components/CardProperty'
import CardPropertyLink from 'Components/CardPropertyLink'
import FileInput from 'Components/FileInput'
import Permissions from 'Components/Permissions'

const PictureCardActions = props => {
  const { picture, setPrimary, uploadDesignerPicture } = props

  return (
    <Permissions
      permissions={['picture.action.uploadDesignerPicture', 'picture.action.setAsPrimary']}
      render={() => (
        <Card.Content extra>
          <List>
            <Permissions
              permissions="picture.action.uploadDesignerPicture"
              render={() => (
                <List.Item>
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a>
                    <FileInput accept="image/tiff,.tif" onChange={uploadDesignerPicture}>
                      <CardProperty icon="upload" popUpContent="Upload Designer Picture">
                        Upload Designer Picture
                      </CardProperty>
                    </FileInput>
                  </a>
                </List.Item>
              )}
            />

            {!picture.primary && (
              <Permissions
                permissions="picture.action.setAsPrimary"
                render={() => (
                  <CardPropertyLink icon="star" onClick={setPrimary} popUpContent="Set Picture as Primary">
                    Set as Primary
                  </CardPropertyLink>
                )}
              />
            )}
          </List>
        </Card.Content>
      )}
    />
  )
}

PictureCardActions.propTypes = {
  picture: PropTypes.object.isRequired,
  setPrimary: PropTypes.func.isRequired,
  uploadDesignerPicture: PropTypes.func.isRequired,
}

export default PictureCardActions
